import React, { useMemo } from "react";
import { Cell } from "fixed-data-table-2";
import { Student } from "../../../../../../../store/onboarding/types";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

type OwnProps = {
  onClick: () => any;
  selectedStudents: Array<Student>;
};

type Props = OwnProps;

const CheckStudentsHeaderCell: React.FunctionComponent<Props> = (props) => {
  const hasSelectedStudents = props.selectedStudents.length > 0;
  const tooltipText = useMemo(() => {
    return hasSelectedStudents
      ? "Create intervention group with selected students"
      : "Select students to create an intervention group";
  }, [hasSelectedStudents]);
  return (
    <Cell className="group-btn">
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id="create-group-tooltip">{tooltipText}</Tooltip>}
      >
        <div>
          <button
            className="blueBtnSm"
            onClick={props.onClick}
            style={{ margin: "auto" }}
            disabled={!hasSelectedStudents}
          >
            CREATE GROUP
          </button>
        </div>
      </OverlayTrigger>
    </Cell>
  );
};

export default CheckStudentsHeaderCell;
